import React from 'react';
import {connect} from 'react-redux';
import {removeTacEntryFromCart} from "../../actions/tacActions";
import {flattenTacEntries} from "../../utils/cartUtils";
import CartElementTacItinerary from "./CartElementTacItinerary";
import CartElementTacBooking from "./CartElementTacBooking";


class CartElementsTac extends React.Component {
    cartElementComponents = {
        itinerary: CartElementTacItinerary,
        booking: CartElementTacBooking,
    };
    render() {
        if(this.props.tacEntries.length === 0) {
            return null;
        }


        const CartElementComponent = this.cartElementComponents[this.props.cartType];
        return (
            <div className="w-full my-2 text-grey-darker">
                {this.props.tacEntries.map((entry) =>
                    <CartElementComponent
                        key={entry.id}
                        entry={entry}
                        removeTacFromCart={(entryId) => {removeTacEntryFromCart(entryId)}}
                        date={this.props.date}
                    />
                )}
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    switch (ownProps.cartType) {
        case 'booking':
            return {
                tacEntries: state.bookings.tac[ownProps.date] ? state.bookings.tac[ownProps.date] : [],
            };
        default:
            if(ownProps.date) {
                return {
                    tacEntries: state.cart.tac[ownProps.date] ? state.cart.tac[ownProps.date] : [],
                };
            }
            return {
                tacEntries: flattenTacEntries(state.cart.tac),
            };
    }
}

export default connect(mapStateToProps) (CartElementsTac);

